export const withConsumers = (InitialComponent, consumers) => {
    return consumers.reduce((WrappedComponent, consumer) => consumer(WrappedComponent), InitialComponent);
};
